import { Popup } from "../../common/popUp";
import { SucessMessageWrapper } from "./styles";
import { useTranslation } from "react-i18next";

function SucessMessage({ message }) {
  const { t } = useTranslation();
  return (
    <Popup>
      <SucessMessageWrapper>
        {!message ? (
          <div>
            {t("password_changed_successfully")}
          </div>
        ) : (
          <div>{message}</div>
        )}
      </SucessMessageWrapper>
    </Popup>
  );
}

export default SucessMessage;
